export class AbleProConfig {
  static layout = 'vertical'; // vertical, horizontal, compact
  static isDarkMode = 'light'; // light, dark, auto-mode
  static theme_color = 'blue-theme'; // blue-theme, indigo-theme, purple-theme, pink-theme, red-theme, orange-theme, yellow-theme, green-theme, teal-theme, cyan-theme
  static isRtlLayout = false; // false true
  static isBox_container = false; // false true
  static theme_contrast = false; //true false
  static menu_caption = false; // true false
  static isLanding = true;
  static i18n = 'en'; // en, fr, ro, cn
}
